import { useLocation } from 'react-router-dom';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Report pages show the PDF and its panel side by side, so they start with the sidebar folded. */
const isReportPage = (pathname: string) => pathname.startsWith('/documents/');

type SidebarState = { collapsed: boolean; reportCollapsed: boolean; toggle: (onReport: boolean) => void };

/** Whether the desktop sidebar is folded to its icon rail, remembered in this browser: once for report pages, once
 * for everything else. */
export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      reportCollapsed: true,
      toggle: (onReport) => { set((s) => (onReport ? { reportCollapsed: !s.reportCollapsed } : { collapsed: !s.collapsed })); },
    }),
    { name: 'ocbc-sidebar' },
  ),
);

/** The sidebar's state on the current page, and the toggle for it. */
export function useSidebar() {
  const onReport = isReportPage(useLocation().pathname);
  const collapsed = useSidebarStore((s) => (onReport ? s.reportCollapsed : s.collapsed));
  const toggle = useSidebarStore((s) => s.toggle);
  return { collapsed, toggle: () => { toggle(onReport); } };
}
